import { Box, Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FAQCard from "../components/FAQCard";
import PageLayout from "../components/PageLayout";
import { useApi } from "../hooks/useApi";
import { FAQ } from "../types/faq";

interface Props {}

const FAQPage: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { data: faqQuery } = useApi<FAQ[]>("faq", undefined, {
    page: 1,
    count: 30,
  });
  const { t } = useTranslation();

  return (
    <PageLayout header={t("FAQ.title")}>
      <Box sx={{ pb: 8 }}>
        <Typography variant="body1">
          {t("FAQ.moreQuestions1")}
          <Link to="/contacts">{t("FAQ.contact")}</Link>
          {t("FAQ.moreQuestions2")}
        </Typography>
      </Box>
      {faqQuery?.results?.map((faq, index) => (
        <FAQCard key={`faq-${index}`} faq={faq} />
      ))}
    </PageLayout>
  );
};

export default FAQPage;
